<template>
  <div>
    <q-select
      :data-cy="nameCypress"
      :label="placeholder"
      :option-label="optionValue"
      :hint="hint"
      :input-debounce="debounce"
      :options="optionsSelect"
      use-input
      emit-value
      map-options
      clearable
      options-dense
      hide-selected
      fill-input
      outlined
      autofocus
      @filter="emitFilter"
      :readonly="isSearching"
      @input="emitInput"
      v-model="inputSelect"
    >
      <template v-slot:no-option>
        <q-item v-if="showNoOption">
          <q-item-section class="text-grey"> {{ noOption }} </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    debounce: {
      type: Number,
      default: 1000
    },
    optionValue: {
      type: String,
      required: true
    },
    noOption: {
      type: String,
      default: ''
    },
    optionsSelect: {
      type: Array,
      required: true,
      default: () => []
    },
    nameCypress: {
      type: String
    },
    isSearching: {
      type: Boolean,
      required: true,
      default: false
    },
    showNoOption: {
      type: Boolean,
      required: false,
      default: () => true
    }
  },
  data: function () {
    return {
      inputSelect: null
    };
  },
  methods: {
    emitFilter (val, update, abort) {
      this.$emit('filterEvent', val, update, abort);
    },
    emitInput (d) {
      this.$emit('input', d);
    }
  }
};
</script>
